/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AlterarSubestipulanteAliases {
  ATTACHMENTS_LIST = 'attachments-list',
  AUTOCOMPLETE_SUBESTIPULANTE = 'autocomplete-subestipulante',
  CARD_0 = 'card-0',
  FETCH_LISTA_ANEXOS = 'fetch-lista-anexos',
  FETCH_SUBESTIPULANTE = 'fetch-subestipulante',
  FIELD_ANEXOS = 'field-anexos',
  FIELD_DATA_SOLICITACAO = 'field-data-solicitacao',
  FIELD_FILE_UPLOADER = 'field-fileUploader',
  FIELD_SUBESTIPULANTE = 'field-subestipulante',
  FIELD_SUBESTIPULANTE_ATUAL = 'field-subestipulante-atual',
  FIELD_TOAST = 'field-toast',
  FILE_UPLOADER = 'file-uploader',
  FORM_ALTERAR_SUBESTIPULANTE = 'form-alterar-subestipulante',
  LAYOUT_ALTERAR_SUBESTIPULANTE = 'layout-alterar-subestipulante',
  LOADER_0 = 'loader-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_1 = 'mapper-1',
  MAPPER_SUBESTIPULANTE = 'mapper-subestipulante',
  PANEL_1 = 'panel-1',
  PANEL_ALTERAR_SUBESTIPULANTE = 'panel-alterar-subestipulante',
  PANEL_LOADER = 'panel-loader',
  TEXT_DATA_SUBESTIPULANTE = 'text-data-subestipulante',
  TEXT_SUBESTIPULANTE = 'text-subestipulante',
  TEXT_SUBESTIPULANTE_ATUAL = 'text-subestipulante-atual',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { AlterarSubestipulanteAliases };
